import { useInfiniteQuery } from '@tanstack/react-query'

import { CAR_STORY_QUERY_KEYS, TOPIC_CONTENTS_PAGE_SIZE } from '../../lib'
import {
  type IPageMycleContentResponse,
  type TMycleContentMenu,
} from '../../model'
import { getMycleContents } from '../request'

interface IUseMycleContentsInfiniteQueryParams {
  menu: TMycleContentMenu
  sort?: string
  categoryId?: number
  size?: number
}

const FIRST_PAGE = 0

/**
 * 메뉴별 콘텐츠 목록 인피니트 스크롤 쿼리.
 * 응답 last 플래그로 다음 페이지 존재 여부 판단.
 */
const useMycleContentsInfiniteQuery = ({
  menu,
  sort,
  categoryId,
  size = TOPIC_CONTENTS_PAGE_SIZE,
}: IUseMycleContentsInfiniteQueryParams) =>
  useInfiniteQuery({
    queryKey: CAR_STORY_QUERY_KEYS.CONTENTS.infinite(
      menu,
      size,
      sort,
      categoryId
    ),
    queryFn: ({ pageParam }) =>
      getMycleContents({ menu, page: pageParam, size, sort, categoryId }),
    getNextPageParam: (lastPage: IPageMycleContentResponse) =>
      lastPage.last ? undefined : lastPage.number + 1,
    initialPageParam: FIRST_PAGE,
    throwOnError: false,
  })

export default useMycleContentsInfiniteQuery
